export default __webpack_public_path__ + "static/media/fybr-logo.965ff2db.svg";